import { useEffect } from 'react'
import { useParams, useLocation, Link } from 'react-router-dom'
import { legal_docs } from './legal_data'

let render_blocks = (doc: typeof legal_docs[number])=>doc.blocks.map((b, i)=>{
  if (b.t == 'h2')
    return <h2 key={i} id={b.id}
      className="scroll-mt-24 text-xl sm:text-2xl font-bold text-gray-900 mt-10 mb-3">
      {b.text}
    </h2>
  if (b.t == 'h3')
    return <h3 key={i}
      className="text-base sm:text-lg font-semibold text-gray-900 mt-6 mb-2">
      {b.text}
    </h3>
  if (b.t == 'ul')
    return <ul key={i}
      className="list-disc pl-6 space-y-1 text-gray-700 mb-4">
      {b.items.map((it, j)=><li key={j}>{it}</li>)}
    </ul>
  return <p key={i} className="text-gray-700 leading-relaxed mb-4">{b.text}</p>
})

export default function Legal_page() {
  let { slug } = useParams()
  let { hash, pathname } = useLocation()
  let doc = legal_docs.find(d=>d.slug == slug)

  useEffect(()=>{
    if (hash) {
      let el = document.getElementById(hash.slice(1))
      if (el) {
        el.scrollIntoView()
        return
      }
    }
    window.scrollTo(0, 0)
  }, [pathname, hash])

  useEffect(()=>{
    if (!doc)
      return
    let title_prev = document.title
    document.title = `${doc.title} - Sponly.ai`
    return ()=>{ document.title = title_prev }
  }, [doc])

  return (
    <div className="min-h-screen bg-white">
      <nav className="fixed top-0 left-0 right-0 bg-white/95 backdrop-blur-md
        border-b border-gray-200 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <Link to="/" className="flex items-center">
              <img src="/logo_sponly_color.svg" alt="Sponly"
                className="h-[28.16px] sm:h-[31.68px] w-auto" />
            </Link>
            <Link to="/"
              className="text-sm font-semibold text-gray-700 hover:text-gray-900">
              ← Back to Sponly
            </Link>
          </div>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-24 pb-16">
        {!doc ? (
          <div className="text-center py-24">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">
              Document not found
            </h1>
            <Link to="/legal/terms" className="text-primary-blue underline">
              View our Terms of Service
            </Link>
          </div>
        ) : (
          <>
            <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-2">
              {doc.title}
            </h1>
            {!!doc.meta.length && (
              <div className="text-sm text-gray-500 mb-8 space-y-0.5">
                {doc.meta.map((m, i)=><div key={i}>{m}</div>)}
              </div>
            )}
            <div className="text-[15px]">{render_blocks(doc)}</div>

            <div className="mt-16 pt-8 border-t border-gray-200">
              <p className="text-sm font-semibold text-gray-900 mb-3">
                Other legal documents
              </p>
              <div className="flex flex-wrap gap-x-4 gap-y-2 text-sm">
                {legal_docs.filter(d=>d.slug != doc.slug).map(d=>(
                  <Link key={d.slug} to={`/legal/${d.slug}`}
                    className="text-primary-blue hover:underline">
                    {d.lbl}
                  </Link>
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  )
}